import {
  fork,
  call,
  put,
  all,
  takeEvery
} from "redux-saga/effects";
import asyncInterface from "../../../../../../asyncInterface";
import history from "../../../../../../history/history";
import {
  getTiffDataType,
  getExpectedExchangeDateType,
  submitTiffFormType,
  getTiffFormInfoType,
  getTiffDisclaimerType,
  fetchPoolDataType,
  fetchUnderlyingFundsType,
  submitUpdateTiffType,
  getAllPoolsType,
  getPoolsInfoType,
  fetchAllPoolDataFromType,
  fetchAccountDataTiffType,
  submitFormDataType,
  formDrupalContentType,
  submitDataSuccessType,
  submitDataErrorType,
  tiffExchangeSuccessType,
  tiffExchangeFailedType,
  tiffInfoSavedType,
  tiffInfoFailedType,
  getTiffDataLoaderType,
  getTiffDataSuccessType,
  getTiffDataFailedType,
  getExpectedExchangeDataLoaderType,
  getExpectedExchangeDataSuccessType,
  getExpectedExchangeDataFailedType,
  tiffDisclaimerSavedType,
  tiffDisclaimerFailedType,
  submitUpdateTiffRequestFailedType,
  getAllPoolsLoaderType,
  getAllPoolsSuccessType,
  getAllPoolsFailedType,
  getPoolsInfoLoaderType,
  getPoolsInfoSuccessType,
  getPoolsInfoFailedType,
  accountDataReceivedSuccessType,
  accountDataReceivedFailedType,
  accountDataReceivedFromSuccessType,
  allPoolDataFromSuccessType,
  allPoolDataFromFailedType,
  beforeSubmitLoaderType,
  afterSubmitLoaderType,
  beforeSubmitSuccessType,
  beforeAfterSubmitFailedType
} from '../../actionTypes'

export function fetchTiffData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendAnExchange.fetchAccountData(fetchPayload.payload);
}

export function submitTiffData(fetchPayload) {
  const fetchData = asyncInterface.init();
  return fetchData.recommendAnExchange.submitExchange(fetchPayload.payload);
}

export function* saveTiffFormWorker(actionObj) {
  try {
    const response = yield call(submitTiffData, actionObj);
    yield put({
      type: tiffExchangeSuccessType,
      payload: response.data.txnId
    });
  } catch (error) {
    yield put({
      type: tiffExchangeFailedType,
      error
    });
  }
}

export function* getTiffFormInfoWorker(actionObj) {
  try {
    const response = yield call(fetchTiffData, actionObj);
    yield put({
      type: tiffInfoSavedType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: tiffInfoFailedType,
      error
    });
  }
}

export function* getTiffDetailsWorker(fetchPayload) {
  yield put({
    type: getTiffDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: getTiffDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: getTiffDataFailedType,
      error
    });
  }
}
export function* getExpectedExchangeDateWorker(fetchPayload) {
  yield put({
    type: getExpectedExchangeDataLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: getExpectedExchangeDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: getExpectedExchangeDataFailedType,
      error
    });
  }
}

export function* getTiffDisclaimerWorker(actionObj) {
  try {
    const response = yield call(fetchTiffData, actionObj);
    yield put({
      type: tiffDisclaimerSavedType,
      payload: response.data[0].field_disclaimer_content
    });
  } catch (error) {
    yield put({
      type: tiffDisclaimerFailedType,
      error
    });
  }
}

export function* poolDataWorker(fetchPayload) {
  try {
    const response = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: "POOL_DATA_SUCCESS",
      payload: response.data
    });
    yield put({
      type: "POOL_DATA_SUCCESS_SET",
      payload: true
    });
  } catch (error) {
    yield put({
      type: "POOL_DATA_REQUEST_FAILED",
      error
    });
  }
}

export function* underlyingFundsWorker(fetchPayload) {
  try {
    const response = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: "UNDERLYING_DATA_SUCCESS",
      payload: response.data
    });
    yield put({
      type: "UNDERLYING_DATA_SUCCESS_SET",
      payload: true
    });
  } catch (error) {
    yield put({
      type: "UNDERLYING_DATA_REQUEST_FAILED",
      error
    });
  }
}

export function* submitUpdateTiffWorker(actionObj) {
  try {
    yield call(submitTiffData, actionObj);
    if (actionObj.payload.selectedTiffOption === "exchangeintoTIFF") {
      history.push({
        pathname: `/view-edit-tiff-into/${actionObj.payload.data.txnId}/edit`
      });
    } else {
      history.push({
        pathname: `/view-edit-tiff-from/${actionObj.payload.data.txnId}/edit`
      });
    }
  } catch (error) {
    yield put({
      type: submitUpdateTiffRequestFailedType,
      error
    });
  }
}

export function* getAllPoolsWorker(fetchPayload) {
  yield put({
    type: getAllPoolsLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: getAllPoolsSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: getAllPoolsFailedType,
      error
    });
  }
}

export function* getPoolsInfoWorker(fetchPayload) {
  yield put({
    type: getPoolsInfoLoaderType,
    payload: ""
  });
  try {
    const response = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: getPoolsInfoSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: getPoolsInfoFailedType,
      error
    });
  }
}

export function* fetchAccountDataTiffWorker(fetchPayload) {
  try {
    const fetchedArr = yield call(fetchTiffData, fetchPayload);
    yield put({
      type: accountDataReceivedSuccessType,
      payload: fetchedArr.data
    });
  } catch (error) {
    yield put({
      type: accountDataReceivedFailedType,
      error
    });
  }
}

export function* fetchAllPoolDataFromWorker(fetchPayload) {
  try {
    const fetchedArr1 = yield call(fetchTiffData, fetchPayload.payload[0]);
    const fetchedArr2 = yield call(fetchTiffData, fetchPayload.payload[1]);
    yield put({
      type: accountDataReceivedFromSuccessType,
      payload: fetchedArr1.data
    });
    yield put({
      type: allPoolDataFromSuccessType,
      payload: fetchedArr2.data
    });
  } catch (error) {
    yield put({
      type: allPoolDataFromFailedType,
      error
    });
  }
}

export function* submitFormDataWorker(actionObj) {
  try {
    const response = yield call(submitTiffData, actionObj);
    yield put({
      type: submitDataSuccessType,
      payload: response.data
    });
  } catch (error) {
    yield put({
      type: submitDataErrorType,
      error
    });
  }
}

export function* formDrupalContentWorker(fetchPayload) {
  yield put({
    type: beforeSubmitLoaderType,
    payload: ""
  });
  yield put({
    type: afterSubmitLoaderType,
    payload: ""
  });
  try {
    const fetchedArr1 = yield call(fetchTiffData, fetchPayload.payload[0]);
    yield put({
      type: beforeSubmitSuccessType,
      payload: fetchedArr1.data
    });
  } catch (error) {
    yield put({
      type: beforeAfterSubmitFailedType,
      error
    });
  }
}

export function* submitTiffFormWatcher() {
  yield takeEvery(submitTiffFormType, saveTiffFormWorker);
}

export function* getTiffFormInfoWatcher() {
  yield takeEvery(getTiffFormInfoType, getTiffFormInfoWorker);
}

export function* getViewTiffDetailsWatcher(fetchPayload) {
  yield takeEvery(getTiffDataType, getTiffDetailsWorker);
}
export function* getExpectedExchangeDateWatcher(fetchPayload) {
  yield takeEvery(getExpectedExchangeDateType, getExpectedExchangeDateWorker);
}
export function* getTiffDisclaimerWatcher() {
  yield takeEvery(getTiffDisclaimerType, getTiffDisclaimerWorker);
}

export function* poolDataWatcher() {
  yield takeEvery(fetchPoolDataType, poolDataWorker);
}

export function* underlyingFundsWatcher() {
  yield takeEvery(fetchUnderlyingFundsType, underlyingFundsWorker);
}

export function* submitUpdateTiffWatcher() {
  yield takeEvery(submitUpdateTiffType, submitUpdateTiffWorker);
}

export function* getAllPoolsWatcher() {
  yield takeEvery(getAllPoolsType, getAllPoolsWorker);
}

export function* getPoolsInfoWatcher() {
  yield takeEvery(getPoolsInfoType, getPoolsInfoWorker);
}

export function* fetchAllPoolDataFrom() {
  yield takeEvery(fetchAllPoolDataFromType, fetchAllPoolDataFromWorker);
}

export function* fetchAccountDataTiff() {
  yield takeEvery(fetchAccountDataTiffType, fetchAccountDataTiffWorker);
}

export function* submitFormDataWatcher() {
  yield takeEvery(submitFormDataType, submitFormDataWorker);
}

export function* formDrupalContentWatcher() {
  yield takeEvery(formDrupalContentType, formDrupalContentWorker);
}

export default function* tiffWatcher() {
  yield all([
    fork(submitTiffFormWatcher),
    fork(getTiffFormInfoWatcher),
    fork(getViewTiffDetailsWatcher),
    fork(getExpectedExchangeDateWatcher),
    fork(getTiffDisclaimerWatcher),
    fork(poolDataWatcher),
    fork(underlyingFundsWatcher),
    fork(submitUpdateTiffWatcher),
    fork(getAllPoolsWatcher),
    fork(getPoolsInfoWatcher),
    fork(fetchAllPoolDataFrom),
    fork(fetchAccountDataTiff),
    fork(submitFormDataWatcher),
    fork(formDrupalContentWatcher)
  ]);
}
